export const PRIORITY_DELIVERY_ENDPOINT = '/Account/GetStatusDisplayRedeemPriorityDelivery';
